document.addEventListener("DOMContentLoaded", function () {
  // Collapse collapsible sections - reduced from 500ms delay to 100ms for TBT
  // Keeping small delay to ensure DOM elements from third-party apps are ready
  setTimeout(function(){
    document.querySelectorAll(".cex-collapsible").forEach(function(el){
      el.open = false;
    });
  }, 100);

  if (!window.matchMedia("(max-width: 767px)").matches) return;

  document.querySelectorAll(".slider-wrapper").forEach(sliderWrapper => {
    const sliderTrack = sliderWrapper.querySelector(".slider-track");
    const dots = sliderWrapper.querySelectorAll(".slider-dot");
    if (!sliderTrack || dots.length === 0) return;

    let currentSlide = 0;
    const totalSlides = dots.length;

    function goToSlide(index) {
      currentSlide = index;
      const offset = -index * 100;
      sliderTrack.style.transform = `translateX(${offset}%)`;
      dots.forEach(dot => dot.classList.remove("active"));
      dots[index].classList.add("active");
    }

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => goToSlide(index));
    });

    let startX = 0;
    let isDown = false;

    sliderTrack.addEventListener("touchstart", e => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    sliderTrack.addEventListener("touchend", e => {
      let endX = e.changedTouches[0].clientX;
      handleSwipe(endX - startX);
    });

    sliderTrack.addEventListener("mousedown", e => {
      isDown = true;
      startX = e.clientX;
    });

    sliderTrack.addEventListener("mouseup", e => {
      if (!isDown) return;
      isDown = false;
      handleSwipe(e.clientX - startX);
    });

    function handleSwipe(diff) {
      if (Math.abs(diff) > 50) {
        if (diff < 0 && currentSlide < totalSlides - 1) {
          goToSlide(currentSlide + 1);
        } else if (diff > 0 && currentSlide > 0) {
          goToSlide(currentSlide - 1);
        }
      }
    }

    goToSlide(0);
  });
});
